import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { money } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function Cart() {
  const { items, update, remove, subtotal } = useCart();
  const nav = useNavigate();
  const shipping = subtotal >= 200 || subtotal === 0 ? 0 : 8;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16 py-14">
      <h1 className="font-display text-4xl lg:text-5xl font-light mb-10">Votre panier</h1>
      {items.length === 0 ? (
        <div className="py-20 text-center">
          <p className="text-neutral-500">Votre panier est vide.</p>
          <Link to="/catalogue" className="btn btn-dark mt-6">Découvrir les créations</Link>
        </div>
      ) : (
        <div className="grid lg:grid-cols-[1fr_360px] gap-12">
          <div>
            {items.map((it, i) => (
              <div key={i} className="flex gap-5 py-6 border-b border-neutral-100" data-testid={`cart-page-line-${i}`}>
                <Link to={`/produit/${it.product_id}`} className="w-28 h-36 bg-neutral-100 overflow-hidden shrink-0">
                  <img src={it.image} alt="" className="w-full h-full object-cover" />
                </Link>
                <div className="flex-1">
                  <p className="over text-[0.6rem] text-[#8E8E93]">{it.creator_name}</p>
                  <Link to={`/produit/${it.product_id}`} className="font-display text-xl">{it.name}</Link>
                  {it.variant_label && <p className="text-sm text-neutral-500 mt-1">{it.variant_label}</p>}
                  <div className="flex items-center gap-6 mt-4">
                    <div className="flex items-center border border-neutral-200">
                      <button onClick={() => update(i, it.quantity - 1)} className="px-2.5 py-1.5"><Minus size={13} /></button>
                      <span className="px-3 text-sm">{it.quantity}</span>
                      <button onClick={() => update(i, it.quantity + 1)} className="px-2.5 py-1.5"><Plus size={13} /></button>
                    </div>
                    <button onClick={() => remove(i)} className="text-neutral-400 hover:text-[#E0115F] flex items-center gap-1 text-xs"><Trash2 size={14} /> Retirer</button>
                  </div>
                </div>
                <span className="text-sm">{money(it.price * it.quantity)}</span>
              </div>
            ))}
          </div>
          <div className="bg-[#FAFAFA] p-7 h-fit">
            <span className="over text-xs">Récapitulatif</span>
            <div className="mt-5 space-y-3 text-sm">
              <div className="flex justify-between"><span className="text-neutral-500">Sous-total</span><span>{money(subtotal)}</span></div>
              <div className="flex justify-between"><span className="text-neutral-500">Livraison</span><span>{shipping === 0 ? "Offerte" : money(shipping)}</span></div>
              <div className="hairline my-4" />
              <div className="flex justify-between text-base"><span>Total</span><span>{money(subtotal + shipping)}</span></div>
            </div>
            <button onClick={() => nav("/checkout")} className="btn btn-magenta w-full mt-6" data-testid="cart-page-checkout">Passer la commande</button>
          </div>
        </div>
      )}
    </div>
  );
}
